module.exports = __webpack_public_path__ + "media/images/headphones-mic-05ca6c3b60a3af30177341311ca5b570.svg";